module.exports = __webpack_public_path__ + "img/polygon.8c66ba12.png";